import { storeToRefs } from 'pinia';
import { computed, watch } from 'vue';
import { useNetworkState } from '@ilteducation/network-state';
import myAccountStore, { MyAccountStore } from './my-account-store';
import { updateMe as updateMeApi } from './api';

const useMyAccount = (loadImmediately = false) => {
  const { isOnline } = useNetworkState();
  const store = myAccountStore();
  const { me, isLoading } = storeToRefs(store) as unknown as MyAccountStore;
  const { load, reset } = store;

  if (loadImmediately) {
    load();
  }

  watch(isOnline, async () => {
    await load();
  });

  const hasSpeakingBookRights = computed((): boolean => {
    if (!me.value) {
      load();
      return false;
    }
    return me.value.speakingBookRights;
  });

  const updateMe = async (params: any) => {
    const response = await updateMeApi(params);
    return response;
  };

  return {
    isLoading,
    load,
    hasSpeakingBookRights,
    me,
    updateMe,
    reset,
  };
};

export default useMyAccount;
